import React from "react";
import * as Icons from "lucide-react";

// Renders a lucide icon by string name with a safe fallback.
export const Icon = ({ name, ...props }) => {
  const Cmp = Icons[name] || Icons.Square;
  return <Cmp {...props} />;
};

export default Icon;
